
class ScrollNavigation {
  constructor() {
    this.scrollNav        = document.getElementById('js-scroll-nav')
    if (this.scrollNav === null) {
      return
    }
    this.scrollNavAnchors = this.scrollNav.querySelectorAll('li a')
    this.currentAnchor    = this.scrollNav.querySelector('.-is-current')


    this._init()
  }

  _init() {
    this.scrollNavAnchors.forEach(anchor => {
      anchor.addEventListener('click', e => {
        const terget = e.currentTarget
        const flag = terget.classList.contains('-is-current')
  
        if (flag) {
          return
        } else {
          this.currentAnchor.classList.remove('-is-current')
          terget.classList.add('-is-current')
          this.currentAnchor = terget
        }
      })
    })
  }
}

new ScrollNavigation()
